/**
 * @fileoverview CentroCostoRepository - Repository for centro_costo collection
 */

import { DataRepository } from './base/DataRepository';
import type { CentroCosto, CentroCostoExpanded } from '../types/collections/CentroCosto';
import { RepositoryError } from './base/DataRepository';

/**
 * Repository for managing CentroCosto records
 * Extends DataRepository with CentroCosto-specific methods
 */
export class CentroCostoRepository extends DataRepository<CentroCosto> {
  constructor() {
    super('centro_costo');
  }

  /**
   * Get all active centros de costo
   * @returns Array of active centros de costo
   */
  async getAllActive(): Promise<CentroCosto[]> {
    try {
      return await this.getAll({
        filter: 'activo = true',
        sort: 'nombre'
      });
    } catch (error) {
      throw new RepositoryError(
        `Error al obtener centros de costo activos: ${error instanceof Error ? error.message : String(error)}`,
        'GET_ALL_ACTIVE_ERROR'
      );
    }
  }
}

